import React from 'react';

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(_error, errorInfo) {
    this.setState({
      hasError: true,
      errorInfo: errorInfo
    });
    // TODO: Log to rollbar
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong</h1>
          <p>
            Try refreshing this page. If the problem persists, contact a UVC
            Administrator
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RootErrorBoundary;
